import React from 'react';
import styled from '@emotion/styled'
import { Spacer200 } from '../../';
import CaseComponent from '../../caseList/case.component';

const ThoughtFeaturedCaseComponent = (props) => (
  <ThoughtFeaturedCase>
    <Spacer200 />
    <Wrapper>
      <CaseComponent {...props.case} />
    </Wrapper>
    <Spacer200 />
  </ThoughtFeaturedCase>
);

const ThoughtFeaturedCase = styled.div`
    background-color: #eee;
`;
const Wrapper = styled.div`
    max-width: ${100 / 18 * 4}vw;
    margin: 0 auto;
`;

export default ThoughtFeaturedCaseComponent;
